import { isEmpty } from 'lodash/fp'

export const getReceivedResellerAgreementSearchParams = (
  input?: string,
  selectedInput?: string
) => {
  if (isEmpty(input)) {
    return {}
  }
  switch (selectedInput) {
    case 'agreement_name':
      return { agreementName: input }
    case 'isv_name':
      return { isvName: input }
    default:
      return {}
  }
}
